import React, { useState } from 'react';
import { X, ShieldCheck } from 'lucide-react';
import { getToken } from "../api/utils";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const MediaTagAccessModal = ({ media, allTags, onClose, onRefresh }) => {
  // Initialize with tags already assigned to this media
  const [localTagIds, setLocalTagIds] = useState(
    // media.permitted_tags?.map(t => t.id) || []
    media.permitted_tags ? media.permitted_tags.map(link => link.tag.id) : []
  );
  const [isSaving, setIsSaving] = useState(false);

  const toggleTag = (tagId) => {
    setLocalTagIds(prev => 
      prev.includes(tagId) ? prev.filter(id => id !== tagId) : [...prev, tagId]
    );
  };

  const handleSync = async () => {
    setIsSaving(true);
    try {
      const response = await fetch(`${API_URL}/guests/media/${media.id}/tags-sync`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json", 
          Authorization: `Bearer ${getToken()}` 
        },
        body: JSON.stringify({ ids: localTagIds }),
      });

      if (response.ok) {
        await onRefresh(); 
        onClose();
      }
    } catch (err) {
      alert("Failed to update media access.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-[40px] w-full max-w-sm shadow-2xl relative">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h4 className="font-black text-gray-900 text-xl">Grant Tag Access</h4>
            <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">
              Media: {media.name}
            </p>
          </div>
          <button onClick={onClose} className="text-gray-300 hover:text-gray-900 transition-colors">
            <X size={24} />
          </button>
        </div>

        <div className="space-y-2 max-h-72 overflow-y-auto mb-8 pr-2 custom-scrollbar">
          {allTags.filter(t => t.name !== "All").map(tag => {
            const isSelected = localTagIds.includes(tag.id);
            return (
              <button
                key={tag.id}
                onClick={() => toggleTag(tag.id)}
                className={`w-full text-left p-4 rounded-2xl font-bold text-sm transition-all border-2 flex justify-between items-center ${
                  isSelected 
                    ? "bg-pink-50 border-[#ff0099] text-[#ff0099]" 
                    : "bg-gray-50 border-transparent text-gray-500 hover:bg-gray-100"
                }`}
              >
                <span>#{tag.name}</span>
                {isSelected && <ShieldCheck size={18} />}
              </button>
            );
          })}
        </div>

        <button
          onClick={handleSync}
          disabled={isSaving}
          className="w-full py-4 bg-gray-900 text-white rounded-2xl font-black uppercase tracking-widest hover:bg-[#ff0099] transition-all disabled:opacity-50 shadow-lg"
        >
          {isSaving ? "Updating..." : "Save Access"}
        </button>
      </div>
    </div>
  );
};